import React from 'react'

const StakingCard = ({ children, className = "" }) => (
  <div className={`relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 p-[1px] ${className}`}>
    <div className="relative bg-white dark:bg-gray-800 p-6 rounded-2xl h-full">
      {children}
    </div>
  </div>
);

export default StakingCard
